import cognito from './cognito'
import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
import DisplayjobView from './components/views/Displayjob.vue'
import JobdashboardView from './components/views/Jobdashboard.vue'
import ScheduleJobdashboardView from './components/views/DisplayjobSchedule.vue'
import ScheduleJobView from './components/views/Schedulejob.vue'
import ForceChangePassword from './components/views/ForceChangePassword.vue'
import ForgetPassword from './components/views/ForgotPassword.vue'
import PasswordReset from './components/views/PasswordReset.vue'
// import Slidesin from './components/JustEatDataCheck.slides.html'
// import Slides from './components/views/Slides.vue'
import DTStatus from './components/views/DataTranferStatus'
// import DisplayjobViewTest from './components/views/Displayjob-1.vue'
import DashboardModuleView from './components/views/DashboardModule.vue'

const requireAuth = (to, from, next) => {
  cognito
    .isAuthenticated()
    .then(session => {
      next()
    })
    .catch(session => {
      next({
        path: '/login'
      })
    })
}

const logout = (to, from, next) => {
  cognito.logout()
  next('/login')
}
// const requireAuth = (to, from, next) => {
//   cognito
//     .isAuthenticated()
//     .then(session => {
//       next()
//     })
//     .catch(session => {
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     })
// }

// const logout = (to, from, next) => {
//   cognito.logout()
//   next('/login')
// }

// Routes passwordreset
const routes = [
  {
    path: '/logout',
    beforeEnter: logout
  },
  {
    path: '/login',
    component: LoginView,
    name: 'login'
  },
  {
    path: '/changepassword',
    component: ForceChangePassword,
    name: 'ForceChangePassword'
  },
  {
    path: '/passwordreset',
    component: PasswordReset,
    name: 'PasswordReset'
  },
  {
    path: '/forgetpassword',
    component: ForgetPassword,
    name: 'ForgetPassword'
  },
  {
    path: '/',
    component: DashView,
    children: [
      // {
      //   path: '/changepassword',
      //   component: ForceChangePassword,
      //   name: 'changepassword',
      //   meta: { description: 'Change Password' }
      // },
      // {
      //   path: '/testdash',
      //   component: DisplayjobViewTest,
      //   name: 'Dashboard1',
      //   beforeEnter: requireAuth,
      //   meta: { description: 'Dashboard1' }
      // },
      {
        path: '/',
        component: DisplayjobView,
        name: 'Dashboard',
        beforeEnter: requireAuth,
        meta: { description: 'Dashboard' }
      },
      {
        path: 'report',
        component: JobdashboardView,
        name: 'Report',
        alias: '',
        meta: { description: 'Report' }
      },
      {
        path: 'DashboardModule',
        component: DashboardModuleView,
        name: 'DashboardModule',
        alias: '',
        meta: { description: 'Dashboard Module' }
      },
      {
        path: 'DisplaySchedule',
        component: ScheduleJobdashboardView,
        name: 'DisplaySchedule',
        alias: '',
        meta: { description: 'Schedule Dashboard' }
      },
      {
        path: 'Schedule',
        component: ScheduleJobView,
        name: 'Schedule',
        alias: '',
        meta: { description: 'Schedule a Job' }
      },
      {
        path: 'DTStatus',
        component: DTStatus,
        name: 'DTStatus',
        alias: '',
        meta: { description: 'Data Transfer Status' }
      }
    ]
  },
  {
    // not found handler sdasd
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js